import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSellers } from "./sellersApi";

export const fetchSellersThunk = createAsyncThunk(
    "sellers/fetchAll",
    async (payload, { rejectWithValue, signal }) => {
        try {
            const data = await fetchSellers(payload, signal);
            return data;
        } catch (error) {
            console.error("Error in thunk:", error);
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);
